<template>
  <div ref="container"><div id="mount-point"></div></div>
</template>

<script>
import Vue from 'vue';
import ContentArea from './content-area.component.vue';


export default Vue.extend({
  name: 'Markdown',
  props: {
    text: {
      type: String,
      default: '',
    },
    dynamic: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    text() {
      if (this.dynamic) {
        const newMountPoint = document.createElement('div');
        newMountPoint.id = 'mount-point';
        this.$refs.container.replaceChild(newMountPoint, this.$refs.container.childNodes[0]);
        this.addContent();
      }
    },
  },
  methods: {
    addContent() {
      const contentArea = Vue.extend(ContentArea);

      new contentArea({propsData: {text: this.text}}).$mount('#mount-point');
    },
  },
  mounted() {

    this.addContent();

  },
});
</script>
